
import GridBodyRowCell from './index';
import { GridSizeStylesProps } from '../../../mixins/grid-size-styles';
import { GridCellCommonPropsType, GridColumnMoneyOptionsType } from '../../../enums';
import NumberFormat from '../../../../../helpers/NumberFormatHelper';
import {
  CommonCellProps,
  CommonCellComputed,
} from './mixins/common-cell-props';

export default {
  name: 'GridBodyRowCellMoney',
  components: { GridBodyRowCell },
  mixins: [CommonCellProps, CommonCellComputed, GridSizeStylesProps],
  computed: {
    formattedValue() {
      const value = this.cell[GridCellCommonPropsType.Value];
      const currency = this.options[GridColumnMoneyOptionsType.Currency];

      return NumberFormat.formatCurrency(value, currency);
    },
  },
};
